module.exports = __webpack_public_path__ + "img/ctc-logo-7-18-2025.ec7c6109.png";